import { Outlet } from 'react-router-dom';

const Process = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Process;
